<template>
  <div class="sidebar bg-magnolia round-10 br-one">
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-15">Search</h3>
      <form action="#" class="search-form">
        <input
          type="search"
          placeholder="Search"
          class="bg-white w-100 round-6 fs-15 mb-15"
        />
        <button type="submit" class="btn style-one border-0 d-block w-100">
          Search Now
        </button>
      </form>
    </div>
    <div class="sidebar-widget author-widget">
      <div class="author-img round-10 mb-20">
        <img
          src="../../assets/img/blog/author-1.webp"
          alt="Image"
          class="round-10 w-100"
        />
      </div>
      <h3 class="fs-26 lh-36 text-center mb-0">Willium Smith</h3>
      <span class="text-center d-block">Content Blogger</span>
    </div>
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-15">Categories</h3>
      <ul class="category-list list-style">
        <li>
          <router-link to="/posts-by-category">
            Marketing
            <span>(09)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/posts-by-category">
            Education
            <span>(03)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/posts-by-category">
            Machine
            <span>(02)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/posts-by-category">
            Business
            <span>(05)</span>
          </router-link>
        </li>
        <li>
          <router-link to="/posts-by-category">
            Digital Marketing
            <span>(07)</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-20">Latest Posts</h3>
      <div class="pp-post-item-wrap">
        <div class="pp-post-item d-flex align-items-center">
          <div class="pp-post-img rounded-1">
            <img
              src="../../assets/img/blog/post-thumb-1.webp"
              alt="Image"
              class="rounded-1"
            />
          </div>
          <div class="pp-post-info">
            <span> 23 Nov, 2023 </span>
            <h5 class="fs-18 mb-0 mt-1">
              <router-link to="/blog-details-right-sidebar">
                How and why you should use google an the ads for
              </router-link>
            </h5>
          </div>
        </div>
        <div class="pp-post-item d-flex align-items-center">
          <div class="pp-post-img rounded-1">
            <img
              src="../../assets/img/blog/post-thumb-2.webp"
              alt="Image"
              class="rounded-1"
            />
          </div>
          <div class="pp-post-info">
            <span> 15 Nov, 2023 </span>
            <h5 class="fs-18 mb-0 mt-1">
              <router-link to="/blog-details-right-sidebar">
                Top 10 tips to boost your site traffic in 2023
              </router-link>
            </h5>
          </div>
        </div>
        <div class="pp-post-item d-flex align-items-center">
          <div class="pp-post-img rounded-1">
            <img
              src="../../assets/img/blog/post-thumb-3.webp"
              alt="Image"
              class="rounded-1"
            />
          </div>
          <div class="pp-post-info">
            <span>11 Nov, 2023</span>
            <h5 class="fs-18 mb-0 mt-1">
              <router-link to="/blog-details-right-sidebar">
                4 key content marketing trends for 2023
              </router-link>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-widget">
      <h3 class="fs-20">Taglist</h3>
      <ul class="tag-list list-style">
        <li><router-link to="/posts-by-tag">Business</router-link></li>
        <li><router-link to="/posts-by-tag">Education</router-link></li>
        <li><router-link to="/posts-by-tag">Marketing</router-link></li>
        <li><router-link to="/posts-by-tag">SEO</router-link></li>
        <li><router-link to="/posts-by-tag">Online</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarWidget",
};
</script>